import { createSlice } from "@reduxjs/toolkit";

import axios from "axios";


const initialState={
    loading:false,
    data:null
}


export const SubmitFormSlice=createSlice({
    name:"SubmitSlice",
    initialState,
    reducers:{

        SubmitStart: (state)=>{
            state.loading=true
            state.data=null
        },
        SubmitSuccess: (state,action)=>{
            state.loading=false
            state.data=action.payload

        },
        SubmitFail: (state,action)=>{
            state.loading=false
            state.data=null

        }


    }
})


export const {SubmitStart,SubmitSuccess,SubmitFail}=SubmitFormSlice.actions


export const SubmitFormFunc=(formId,val,userId)=>async(dispatch)=>{
let url='http://18.132.190.48:8080/api/v1/form'
dispatch(SubmitStart())
try{
    const res=await axios.put(`${url}/submit/${formId}?userId=${userId}`,val)
    console.log(res)
   return  dispatch(SubmitSuccess(res))
}
catch(err){
   return dispatch(SubmitFail(err))
}
}


export default SubmitFormSlice.reducer